import TabelSceduler from "./TabelSceduler";

export default TabelSceduler;